import React, { useState, useEffect } from 'react';
import styles from './docsInput.module.css';
import { textStyles } from '../../../constants/textStyles';
import { colors } from '../../../constants/colors';
import Hint from '../../Hint';

const DocsInputNew = ({ text, label, onChange, placeholder, value, style = {}, id, required, error, hint, accept="*/*", showImage, imageUrl, multiple = false, clientFile, onRemoveClientFile, ...props }) => {
  const [previewUrls, setPreviewUrls] = useState([]);

  useEffect(() => {
    return () => {
      previewUrls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previewUrls]);

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      if (multiple && Array.isArray(value) && value.length > 0) {
        const merged = [...value, ...fileArray];
        const mergedPreviewUrls = merged.map(file => URL.createObjectURL(file));
        setPreviewUrls(mergedPreviewUrls);
        onChange(merged);
      } else {
        const newPreviewUrls = fileArray.map(file => URL.createObjectURL(file));
        setPreviewUrls(newPreviewUrls);
        onChange(multiple ? fileArray : fileArray[0]);
      }
    } else {
      setPreviewUrls([]);
      onChange(multiple ? [] : null);
    }
  };

  const removeFile = (e, idx = null) => {
    e.stopPropagation();
    if (multiple && Array.isArray(value)) {
      if (idx === null) {
        setPreviewUrls([]);
        onChange([]);
      } else {
        const newFiles = value.filter((_, i) => i !== idx);
        const newPreviewUrls = previewUrls.filter((_, i) => i !== idx);
        setPreviewUrls(newPreviewUrls);
        onChange(newFiles);
      }
    } else {
      setPreviewUrls([]);
      onChange(null);
    }
  };

  // Файл прислал клиент по ссылке: показываем его в самом поле, с просмотром и удалением.
  const fromClient = clientFile && !(multiple ? Array.isArray(value) && value.length > 0 : value?.name);
  const sentAt = clientFile?.createdAt
    ? new Date(clientFile.createdAt).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

  return (
    <div className={styles.input} style={style}>
      <p style={textStyles.fieldLabel}>
        {text} {required && <span style={{ color: colors.red }}>*</span>}
        {hint && <Hint text={hint} />}
      </p>
      <div className={styles.container}>
        {fromClient ? (
          <>
            <div className={styles.clientFile}>
              <span>✓ Прислал клиент{sentAt && ` · ${sentAt}`}</span>
              <a href={clientFile.url} target="_blank" rel="noreferrer">
                Открыть
              </a>
            </div>
            <svg
              onClick={() => onRemoveClientFile && onRemoveClientFile()}
              className={styles.deleteBtn}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
              aria-label="Удалить документ клиента"
            >
              <path
                d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"
                fill="#BABABA"
              />
            </svg>
          </>
        ) : (
        <>
        <label htmlFor={id} style={{ borderColor: error ? colors.red : colors.alto }}>
          {multiple
            ? (Array.isArray(value) && value.length > 0 ? value.map(f => f.name).join(', ') : label)
            : (value?.name || label)
          }
        </label>
        {(multiple ? Array.isArray(value) && value.length > 0 : value?.name) && (
          <svg
            onClick={e => removeFile(e, null)}
            className={styles.deleteBtn}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"
              fill="#BABABA"
            />
          </svg>
        )}
        </>
        )}
      </div>
      <input
        type="file"
        id={id}
        placeholder={placeholder}
        onChange={(e) => {
          handleFileChange(e.target.files);
        }}
        onClick={(e) => (e.target.value = null)}
        hidden
        accept={accept}
        multiple={multiple}
        {...props}
      />
      {showImage && (
        multiple && Array.isArray(value) && value.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {previewUrls.map((url, idx) => (
              <div key={idx} style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  src={url}
                  style={{ width: 120, margin: '0 auto', display: 'block' }}
                  alt={`preview-${idx}`}
                />
                <svg
                  onClick={e => removeFile(e, idx)}
                  className={styles.deleteBtn}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }}
                >
                  <path
                    d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"
                    fill="#BABABA"
                  />
                </svg>
              </div>
            ))}
          </div>
        ) : (
          (previewUrls[0] || imageUrl) && (
            <img
              src={previewUrls[0] || imageUrl}
              style={{ width: 200, margin: '0 auto' }}
              alt='preview'
            />
          )
        )
      )}
    </div>
  );
};

export default DocsInputNew;